import { render, staticRenderFns } from "./CigPricing.vue?vue&type=template&id=5cd61ef6&"
import script from "./CigPricing.vue?vue&type=script&lang=js&"
export * from "./CigPricing.vue?vue&type=script&lang=js&"
import style0 from "./CigPricing.vue?vue&type=style&index=0&id=5cd61ef6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports